import api from '../api';

export const getListMenu = async () => {
    const result = await api.get('/admin/menu');
    return result.data;
}

export const getOneMenu = async (type) => {
    const result = await api.get(`/admin/menu/${type}`);
    return result.data;
}

export const getOneItemMenu = async (id) => {
    const result = await api.get(`/admin/menu/item/${id}`);
    return result.data.menu[0];
}

export const createMenu = async (data, type) => {
    try {
        const response = await api.post(`/admin/menu/${type}`, data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateMenu = async (data, type, id, lang) => {
    return await api.post(`/admin/menu/${type}/${id}`, data, {
        headers: {
            "Accept-Language": lang
        }
    });
}

export const deleteMenu = async (id) => {
    try {
        const response = await api.delete(`/admin/menu/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusMenu = async (id) => {
    try {
        const response = await api.post(`/admin/status/menu/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateOrderMenu = async (data, type) => {
    try {
        const response = await api.put(`/admin/order/menu/${type}`, { data });
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}


